import {
  Autocomplete,
  Grid,
  MenuItem,
  Select,
  TextField,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import Input from "../Components/Input";
import CustomButton from "../Components/Button";
import {
  GuestCreation,
  getEmployeeDropdown,
  getEmployeeSuggestions,
} from "../Dashboard/mutations/guestCreation";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { handleToastMsg } from "../Components/Toast";
import CameraComponent from "../Components/CameraComponent";

const FormWrapper = styled(Grid)`
padding: 4% 8%;

  /* @media (min-width: 960px) {
    padding: 40px 80px;
  } */

  .MuiOutlinedInput-root {
    padding: 0;
  }
  .MuiOutlinedInput-root {
    padding: 0;
  }

  .MuiAutocomplete-input {
    padding: 16px !important;
  }

  .MuiAutocomplete-root {
    padding: 0 !important;
  }

  .submitBtn-container {
    display: flex;
    justify-content: center;

    @media (min-width: 768px) {
      justify-content: flex-end;
    }
  }
`;

function RelationGuestComponent({ isNotMobile, setStepper }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(600));

  const [visitorName, setVisitorName] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [relation, setRelation] = useState("");
  const [capturedImage, setCapturedImage] = useState(null);

  const [imageBoxVisible, setImageBoxVisible] = useState(true); // Track the ImageBox visibility
  const [mediaStream, setMediaStream] = useState(null);
  const [showCapture, setShowCapture] = useState(false);
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(GuestCreation);

  const { data: dropdownData } = useQuery("employee-relation-dropdown", () =>
    getEmployeeDropdown()
  );

  const { data: employeeSuggestions } = useQuery("employee-suggestion", () =>
    getEmployeeSuggestions()
  );

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      visitor_name: visitorName,
      employee_name: employeeName,
      relationship: relation,
      image: capturedImage,
    };

    console.log({ payload });

    mutate(payload, {
      onSuccess: (res) => {
        setVisitorName("");
        setEmployeeName("");
        setRelation("");
        queryClient.invalidateQueries("get-org-data");
        queryClient.invalidateQueries("get-relation-data");
        handleToastMsg("Entry added");
        resetForm();
        clearImage();
        if (isNotMobile) {
          setStepper("QUEUE");
        }
        // navigate("/", { replace: true });
      },
      onError(err) {
        handleToastMsg(err.message, "Error Occured");
      },
    });
  };

  const resetForm = () => {
    setVisitorName("");
    setEmployeeName("");
    setRelation("");
  };

  const clearImage = () => {
    setCapturedImage(null);
    mediaStream.getTracks().forEach((track) => track.stop());
    setImageBoxVisible(true);
    setShowCapture(false);
  };

  return (
    <form onSubmit={handleSubmit} style={{ width: "100%" }}>
      <FormWrapper item container rowGap={2} justifyContent={"center"}>
        <Grid container item md={6} xs={12} rowGap={3}>

          <Grid item xs={12} md={10} container>
            <Grid item xs={12} alignSelf={"center"}>
              Name
            </Grid>
            <Grid item xs={12} >
              <Autocomplete
                freeSolo
                options={employeeSuggestions ? employeeSuggestions.guests : []}
                onChange={(event, value) => setVisitorName(value)}

                renderInput={(params) => (
                  <TextField
                    {...params}
                    type="text"
                    name="visitor_name"
                    value={visitorName}
                    onChange={(e) => setVisitorName(e.target.value)}
                    fullWidth

                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} md={10} container>
            <Grid item xs={12} alignSelf={"center"}>
              Employee Name(Person to meet)
            </Grid>
            <Grid item xs={12}>
              <TextField
                type="text"
                name="employeeName"
                value={employeeName}
                onChange={(e) => setEmployeeName(e.target.value)}
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid item xs={12} md={10} container>
            <Grid item xs={12} alignSelf={"center"}>
              Relation
            </Grid>
            <Grid item xs={12}>
              <TextField
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={relation}
                onChange={(e) => setRelation(e.target.value)}
                select
                fullWidth
              >
                <MenuItem value={"Father"}>Father</MenuItem>
                <MenuItem value={"Mother"}>Mother</MenuItem>
                <MenuItem value={"Brother"}>Brother</MenuItem>
                <MenuItem value={"Sister"}>Sister</MenuItem>
                <MenuItem value={"Agent"}>Agent</MenuItem>
              </TextField>
            </Grid>
          </Grid>
        </Grid>
        <Grid item container mt={{ xs: 2, md: 3 }} md={6} xs={12}>
          <CameraComponent
            capturedImage={capturedImage}
            setCapturedImage={setCapturedImage}
            setImageBoxVisible={setImageBoxVisible}
            imageBoxVisible={imageBoxVisible}
            setMediaStream={setMediaStream}
            mediaStream={mediaStream}
            showCapture={showCapture}
            setShowCapture={setShowCapture}
          />
        </Grid>
        <Grid
          item
          container
          xs={12}

          justifyContent={isMobile ? "center" : "flex-end"}
        >
          <CustomButton
            type={"submit"}
            disabled={!capturedImage || !employeeName || !visitorName}
            isLoading={isLoading}
          >
            Submit / சமர்ப்பிக்க
          </CustomButton>
        </Grid>
      </FormWrapper>
    </form>
  );
}

export default RelationGuestComponent;
